import { render, staticRenderFns } from "./groupInfo.vue?vue&type=template&id=3fc503ac&scoped=true"
import script from "./groupInfo.vue?vue&type=script&lang=js"
export * from "./groupInfo.vue?vue&type=script&lang=js"
import style0 from "./groupInfo.vue?vue&type=style&index=0&id=3fc503ac&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc503ac",
  null
  
)

export default component.exports